document.addEventListener("DOMContentLoaded", function () {
  const rowsToUpdate = [
    {
      label: "Product Collection",
      endpoint: "/wp-json/wp/v2/collection", // REST API endpoint for the taxonomy
    },
    {
      label: "Product",
      endpoint: "/wp-json/wp/v2/product", // REST API endpoint for the custom post type
    },
  ];

  // Function to process a single table
  function processTable(table) {
    rowsToUpdate.forEach((rowConfig) => {
      const allRows = table.querySelectorAll("tr");

      allRows.forEach((tr) => {
        const labelCell = tr.querySelector("td font");

        if (labelCell && labelCell.textContent.trim() === rowConfig.label) {
          const valueRow = tr.nextElementSibling;

          if (valueRow) {
            const valueCell = valueRow.querySelector("td:nth-child(2) font");
            if (valueCell) {
              const id = valueCell.textContent.trim(); // Extract the ID
              if (id) {
                // Fetch the name/title for the ID
                fetch(`${rowConfig.endpoint}/${id}`)
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                  })
                  .then((data) => {
                    // Replace the cell content with the fetched name/title
                    if (data && data.name) {
                      valueCell.textContent = data.name; // For taxonomy terms
                    } else if (data && data.title && data.title.rendered) {
                      valueCell.textContent = data.title.rendered; // For custom post types
                    } else {
                      console.error(`Name/title not found for ID: ${id}`);
                    }
                  })
                  .catch((error) => {
                    console.error(
                      `Error fetching ${rowConfig.label} for ID ${id}:`,
                      error
                    );
                  });
              }
            }
          }
        }
      });
    });
  }

  // Select all tables
  const tables = document.querySelectorAll("table");

  // Process each table
  tables.forEach((table) => {
    processTable(table);
  });

  // MutationObserver to handle dynamic updates
  const tableParent = document.querySelector(".gpnf-nested-entries"); // Update the selector for your table container
  if (tableParent) {
    const observer = new MutationObserver(() => {
      const updatedTables = tableParent.querySelectorAll("table");
      updatedTables.forEach((table) => {
        processTable(table);
      });
    });

    observer.observe(tableParent, { childList: true, subtree: true });
  }
});
